/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum TenderStatus {

    INVITED = 'INVITED',

    ACCEPTED = 'ACCEPTED',

    PREPARED = 'PREPARED',

    FINISHED = 'FINISHED',

    WON = 'WON',

    WAITING_FOR_CUSTOMER = 'WAITING_FOR_CUSTOMER',

    REJECTED = 'REJECTED',

    EXPIRED = 'EXPIRED',

    LOST = 'LOST',

    UNSET = 'UNSET'
}

